import styled from "styled-components";
import { useSubjectDetailsContext } from "./PolicySubjectDetailsContext";
import { useTranslation } from "react-i18next";

const PolicySubjectResumeInfoWrapper = styled.div`
  border-radius: 0.5em;
  background-color: #fff;
  padding: 0.75em 0;
  margin-bottom: 1em;
  display: flex;
  justify-content: space-around;
  gap: 2em;
  box-shadow: 0 0 2px #aaa;

  .field-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 0.9em;

    .field-label {
      display: flex;
      text-transform: uppercase;
      letter-spacing: 1px;
      line-height: 1.2em;
    }

    .field-value {
      display: flex;
      line-height: 1.2em;
      margin: 0.25em 0 0 0;
    }
  }
`;

const PolicySubjectResumeInfo = () => {
  const { t } = useTranslation();

  const { subject } = useSubjectDetailsContext();

  const nominative =
    subject?.personalData?.subjectType === "PF"
      ? `${subject.personalData?.naturalSubject?.name} ${subject.personalData?.naturalSubject?.lastname}`
      : subject?.personalData?.juridicalSubject?.businessName || "";

  return (
    <PolicySubjectResumeInfoWrapper>
      <div className="field-item">
        <div className="field-label">{t("LABELS.subject-nominative")}</div>

        <div className="field-value">{nominative}</div>
      </div>

      <div className="field-item">
        <div className="field-label">
          {subject?.personalData?.subjectType === "PF"
            ? t("LABELS.subject-fiscal-code")
            : t("LABELS.subject-vat-number")}
        </div>

        <div className="field-value">
          {subject?.personalData?.subjectType === "PF"
            ? subject.personalData?.naturalSubject?.fiscalCode || ""
            : subject?.personalData?.juridicalSubject?.pIva || ""}
        </div>
      </div>
    </PolicySubjectResumeInfoWrapper>
  );
};

export default PolicySubjectResumeInfo;
